"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferencePriceUtils = exports.SupportedReferencePriceCountries = void 0;
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
/**
 * The currently supported reference price countries.
 */
var SupportedReferencePriceCountries;
(function (SupportedReferencePriceCountries) {
    SupportedReferencePriceCountries["US"] = "US";
    SupportedReferencePriceCountries["DE"] = "DE";
})(SupportedReferencePriceCountries = exports.SupportedReferencePriceCountries || (exports.SupportedReferencePriceCountries = {}));
class ReferencePriceUtils {
    /**
     * Checks whether a country is supported by the current priceCountry implementation or not.
     */
    static isSupportedReferencePriceCountry(country) {
        const priceCountry = echain_shared_i18n_1.ShopPriceCountryMapper.toAlpha2CountryCode(country);
        return priceCountry in SupportedReferencePriceCountries;
    }
}
exports.ReferencePriceUtils = ReferencePriceUtils;
//# sourceMappingURL=ReferencePriceUtils.js.map